import { Directive, ElementRef, HostBinding, Input, OnChanges } from '@angular/core';

@Directive({ selector: '[adsptAnimateHeight]' })
export class AnimateHeightDirective implements OnChanges {
  @Input('adsptAnimateHeight')
  animateHeight: boolean;

  height = 0;

  constructor(private el: ElementRef<HTMLElement>) {}

  @HostBinding('@autoHeight')
  get animate() {
    return { value: this.animateHeight, params: { height: this.height } };
  }

  ngOnChanges(): void {
    this.height = this.el.nativeElement.clientHeight;
  }
}
